import React, { Component } from 'react';
import { MDBModal, MDBModalHeader, MDBModalBody, MDBModalFooter, toast, ToastContainer, MDBTableBody, MDBTable, MDBTableHead, MDBCardImage, MDBModalTitle, MDBTooltip, MDBBadge, MDBCardFooter, MDBPageNav, MDBPageItem, MDBPagination, MDBInput, MDBBtn, MDBCard, MDBCardTitle, MDBCardText, MDBCardBody, MDBIcon, MDBRow, MDBCol } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import HeaderShop from './ComponentFragments/HeaderShop';
import SelectSearch from 'react-select-search';

class Shop extends Component {
    constructor(props) {
        super(props);
        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        this.state = ({
            active: true,
            selectedPage: 1,
            shopData: [],
            filteredData: [],
            displayData: [],
            pageSize: 20,
            maxPages: 0,
            pages: [],
            dummy: 0,
            errorModalOpen: false,
            shopErrorMsg: '',
            shopSuspended: false,
            //cartData: [],
            roadshowItem: {},
            dispatchTypeOpen: false,
            deliveryOptions: [],
            deliveryCharges: [],
            filteredCharges: [],
            selectedDeliveryOption: 2,
            selectedDeliveryCharge: 0,

            selectedDeliveryChargeId: 0,
            selectedDeliveryType: 0,

            forDelivery: true,
            isCollection: false,
            checked: false,
            showDeliverToManager: true,
            shopErrorModalOpen: false,
            selectedDispatchText: '',
            hasOpenCart: false,
            cartChecked: false,
            avWarehouseCodeCart: '',
            clearCartModalOpen: false,
            primaryWHModalOpen: false,
            primaryWhModalMsg: '',
            modalType: 1,
            itemForCart: {},
            componentList: [],
            compModalOPen: false
        });
        this.formatter = new Formatter();
        this.searchList = this.searchList.bind(this);
        this.getPagination = this.getPagination.bind(this);
        this.getPage = this.getPage.bind(this);
        this.getShopData = this.getShopData.bind(this);
        this.addToCart = this.addToCart.bind(this);
        this.getParams = this.getParams.bind(this);
        this.getButton = this.getButton.bind(this);
        this.getHot = this.getHot.bind(this);
        this.toggleErrorInfo = this.toggleErrorInfo.bind(this);
        this.filterCharges = this.filterCharges.bind(this);
        this.setChecked = this.setChecked.bind(this);
        this.getDispatchOptions = this.getDispatchOptions.bind(this);
        this.proceedToShop = this.proceedToShop.bind(this);
        this.reloadDispatchOpts = this.reloadDispatchOpts.bind(this);
        this.checkCartOpen = this.checkCartOpen.bind(this);
        this.getAvailability = this.getAvailability.bind(this);
        this.clearCartAndProceed = this.clearCartAndProceed.bind(this);
        this.checkAvailability = this.checkAvailability.bind(this);
        this.addItemToCart = this.addItemToCart.bind(this);
        this.availabilityPreCheck = this.availabilityPreCheck.bind(this);
        this.showComponents = this.showComponents.bind(this);
        this.filterChargesForCart = this.filterChargesForCart.bind(this);
    }

    showComponents(item) {
        this.setState({
            componentList: item.componentList,
            compModalOPen: true 
        })
    }

    setChecked(value) {
        if (value == "false") {
            this.setState({
                checked: true
            })
        } else {
            this.setState({
                checked: false
            })
        }
    }

    filterChargesForCart(dispatchType, dispatchChargeId) {
        let dispCharge = this.state.deliveryCharges.filter((item) => item.dispatchChargeId === dispatchChargeId);
        console.log('FFSFSFSFSFSFSFSFFSFSFSFSFSFSFSF', dispatchType)
        let items = this.state.deliveryCharges.filter((item) => item.dispatchType === dispatchType);

        let filteredCharges = [];
        items.forEach((item) => {
            filteredCharges.push({ name: item.description, value: item })
        })
        this.setState({
            filteredCharges,
            selectedDeliveryOption: dispatchType,
            selectedDeliveryCharge: dispatchChargeId === -1 ? items[0] :  dispCharge[0],
            selectedDeliveryChargeId: dispatchChargeId === -1 ? items[0].dispatchChargeId : dispatchChargeId,
            forDelivery: dispatchType === 1 ? false : true,
            isCollection: dispatchType === 1 ? true : false,
            checked: dispatchType === 1 ? false : this.state.checked,
            selectedDispatchText: dispatchChargeId === -1 ? items[0].description : dispCharge[0].description
        })
    }

    filterCharges(dispatchType) {
        console.log('FFSFSFSFSFSFSFSFFSFSFSFSFSFSFSF', dispatchType)
        let items = this.state.deliveryCharges.filter((item) => item.dispatchType === dispatchType);

        let filteredCharges = [];
        items.forEach((item) => {
            filteredCharges.push({ name: item.description, value: item })
        })
        this.setState({
            filteredCharges,
            selectedDeliveryOption: dispatchType,
            selectedDeliveryCharge: items[0],
            selectedDeliveryChargeId: items[0].dispatchChargeId,
            forDelivery: dispatchType == 1 ? false : true,
            isCollection: dispatchType == 1 ? true : false,
            checked: dispatchType == 1 ? false : this.state.checked,
            selectedDispatchText: items[0].description
        })
        
    }

    async checkCartOpen() {
        var dl = new DataLayer();
        let checkCartOpenResponse = await dl.Get("/shop/checkCartOpen", 0);
        console.log('cart check detailsffffsssssssssssssssssss', checkCartOpenResponse.data);
        //if (checkCartOpenResponse.errorOccurred || !checkCartOpenResponse.data.open) {
        //    this.getDispatchOptions();
        //}
        //this.state.selectedDeliveryCharge.dispatchType

        this.setState({
            cartChecked: true,
            dispatchTypeOpen: checkCartOpenResponse.errorOccurred ? true : checkCartOpenResponse.data.open ? false : true,
            hasOpenCart: checkCartOpenResponse.errorOccurred ? false : checkCartOpenResponse.data.open,
            selectedDispatchText: checkCartOpenResponse.errorOccurred ? '' : checkCartOpenResponse.data.dispatchDescription,
            selectedDeliveryOption: checkCartOpenResponse.errorOccurred ? 2 : checkCartOpenResponse.data.open ? checkCartOpenResponse.data.dispatchType : 2,
            selectedDeliveryChargeId: checkCartOpenResponse.data.dispatchChargeId,
            selectedDeliveryType: checkCartOpenResponse.data.dispatchType,
            checked: checkCartOpenResponse.data.deliverToManager,
            avWarehouseCodeCart: checkCartOpenResponse.data.aVWarehouseCode
        })

        this.filterChargesForCart(checkCartOpenResponse.errorOccurred ? 2 : checkCartOpenResponse.data.open ? checkCartOpenResponse.data.dispatchType : 2,
            checkCartOpenResponse.errorOccurred ? -1 : checkCartOpenResponse.data.open ? checkCartOpenResponse.data.dispatchChargeId : -1)

        let returnObject = {
            DispChargeId: checkCartOpenResponse.data.dispatchChargeId,
            hasOpenCart: checkCartOpenResponse.errorOccurred ? false : checkCartOpenResponse.data.open
        }

        return returnObject;
    }

    toggleErrorInfo() {
        //this.setState({
        //    errorModalOpen: !this.state.errorModalOpen
        //});
        window.location.reload();
        return false;
    }

    async componentWillMount() {
        if (this.TMAUser.data.countryId == 6) {
            await this.getDispatchOptions();


            var cartDetails = await this.checkCartOpen();

            console.log('cart details', cartDetails);
            let dispCharge = this.state.deliveryCharges.filter((item) => item.dispatchChargeId === cartDetails.DispChargeId);
            console.log('dispcharge found', dispCharge)
            //await this.proceedToShop();
            if (dispCharge.length > 0 && cartDetails.hasOpenCart) {
                this.setState({
                    selectedDeliveryCharge: dispCharge[0]
                })
                await this.getShopData(dispCharge[0]);
            }
            this.props.loaderOff();
        } else {
            this.getShopData(undefined);
        }


    }

    async getShopData(dispatchCharge) {
        let avWhCode = '';
        let continueToLoad = true;
        if (dispatchCharge === undefined) {

            avWhCode = 'n-s' //not specified
        } else {
            avWhCode = dispatchCharge.avWarehouseCode;
            //if (dispatchCharge.dispatchType === 2) {
            //    avWhCode = 'prim'
            //}
            if (avWhCode === '') {
                this.setState({
                    shopErrorMsg: 'Unable to load store data. No Linked Warehouse For Dispatch Option.',
                    shopErrorModalOpen: true
                })
                continueToLoad = false;
            }
            console.log('FFSSSSSSSSSSSSSSSSSSSSSSSS*********************', dispatchCharge)
        }
        if (continueToLoad) {
            this.props.loaderOn();
            //let routeParam = this.props.getRouteParam();
            var dl = new DataLayer();
            let suspendedResponse = await dl.Get('/shop/CheckShopSuspended')
            //let cartResponse = await dl.Get("/common/getcart/false", 1);

            //check to see if this dem has already ordered one of the roadshow items.
            let roadShowItemResponse = await dl.Get("/demonstrator/checkForRoadshowItem")

            if (!suspendedResponse.data.mobiOrderingAllowed) {
                this.setState({ shopSuspended: true });
            } else {

                let response = await dl.Get('/common/getshopdata/' + this.props.match.params.categoryId + '/' + this.TMAUser.data.countryId + '/' + avWhCode);

                console.log("fsfchgascha ersponse ", response);
                if (response.errorOccurred) {
                    this.setState({
                        shopErrorMsg: response.errorMessage,
                        shopErrorModalOpen: true
                    })
                } else {
                    this.setState({
                        shopSuspended: false,
                        shopData: response.data,
                        filteredData: response.data,
                        maxPages: Math.ceil(response.data.length / this.state.pageSize),
                        //cartData: cartResponse.data,
                        roadshowItem: roadShowItemResponse.data

                    });

                    this.getPage(1, Math.ceil(response.data.length / this.state.pageSize), response.data);
                }
            }
            this.props.loaderOff();
        }
    }

    async clearCartAndProceed() {
        var dl = new DataLayer();
        let response = await dl.Get('/shop/cancelCart/');
        if (!response.errorOccurred) {
            this.setState({
                clearCartModalOpen: false,
                dispatchTypeOpen: true,
                hasOpenCart: false,
                checked: false
            })
            this.props.updateCartCount(0);
        } else {

        }
    }

    async proceedToShop() {
        console.log('FFFSFFSFFSFSSSSSSSSSSSSSSSSSS ', this.state.selectedDeliveryCharge);
        this.setState({
            dispatchTypeOpen: false
        })

        await this.getShopData(this.state.selectedDeliveryCharge);
    }

    getPage(pageNo, maxPages, data) {
        let lowerBound = pageNo - 4;
        let upperBound = pageNo + 4;
        let pages = [];

        if (maxPages > 9) {
            if (lowerBound < 1) {
                lowerBound = 1;
                upperBound = 9;
            }

            if (upperBound > maxPages) {
                upperBound = maxPages;
                lowerBound = maxPages - 8;
            }
        } else {
            lowerBound = 1;
            upperBound = maxPages;
        }

        for (var i = lowerBound; i <= upperBound; i++) {
            pages.push(i);
        }

        let newData = this.getPageData(this.state.pageSize, pageNo, data);

        this.setState({
            selectedPage: pageNo,
            displayData: newData,
            pages
        })

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    getPageData(pageSize, pageNo, data) {
        let max = (pageSize * pageNo) - 1;
        let min = (max - pageSize) + 1;

        return data.slice(min, max + 1);
    }

    componentDidUpdate(prevProps) {
        var prevParams = prevProps.match.params.categoryId;
        var currParams = this.props.match.params.categoryId;
        if (prevParams !== currParams) {
            if (this.TMAUser.data.countryId == 6) {
                this.getShopData(this.state.selectedDeliveryCharge);
            } else {
                this.getShopData(undefined);
            }
            this.props.loaderOff();
        }
    }

    async getDispatchOptions() {
        var dl = new DataLayer();
        let deliveryCharges = await dl.Get("/common/getdeliveryoptions", 1);

        

        let defaultDelivery = deliveryCharges.data.filter((item) => item.isDefault === true);
        let dispatchType = defaultDelivery[0].dispatchType;
        let payLaterResult = defaultDelivery[0].payLater;

        let procCode1 = this.TMAUser.data.countryId == 6 ? '991527' : '991529';
        let procCode2 = this.TMAUser.data.countryId == 6 ? '991528' : '991530';
        //let item = response.data.cartItems[0]
        let deliveryOptions = [];

        if (deliveryCharges.data.some(e => e.dispatchType === 1)) {
            if (this.TMAUser.data.countryId == 6) {
                //if (item.processingCode == procCode1 || item.processingCode == procCode2) {
                deliveryOptions.push({ name: "Collect", value: 1 })
                dispatchType = 1
                //}
            } else {
                deliveryOptions.push({ name: "Collect", value: 1 })
                dispatchType = 1
            }
        }


        if (deliveryCharges.data.some(e => e.dispatchType === 2)) {
            deliveryOptions.push({ name: "Deliver", value: 2 })
            dispatchType = 2;
        }

        this.setState({
            deliveryCharges: deliveryCharges.data,
            showDeliverToManager: dispatchType === 1 ? false : true,
            selectedDeliveryType: dispatchType,
            selectedDeliveryOption: dispatchType,
            deliveryOptions
        })

        this.filterCharges(dispatchType);
    }

    async checkAvailability(item) {
        var dispType = this.state.selectedDeliveryOption
        var qty = document.getElementById(item.itemKey).valueAsNumber;
        item.fullfillmentWHCode = this.state.selectedDeliveryCharge.avWarehouseCode
        item.reservationWHCode = this.state.selectedDeliveryCharge.avWarehouseCode
        var addToCart = true;
        if (dispType != 2) { //dispType = 2 is for collection, dispType = 1 is for delivery
            if (!item.inStockSecondary || qty > item.onhandSecondary) {
                if (qty > item.onhandPrimary) {
                    addToCart = false;
                    this.setState({
                        primaryWHModalOpen: true,
                        modalType: 2,
                        primaryWhModalMsg: 'Unable to add to cart. There is insufficient quantity on hand to fullfill the quantity you have entered.'
                    })
                } else {
                    addToCart = false;
                    item.reservationWHCode = 'prim';
                    this.setState({
                        primaryWHModalOpen: true,
                        modalType: 1,
                        itemForCart: item,
                        primaryWhModalMsg: 'The item you have chosen can only be fullfilled from the primary warehouse, there may be a delay in your collection point receiving the stock. Do you wish to continue?'
                    })
                }
            }
        } else {
            if (qty > item.onhandPrimary) {
                addToCart = false;
                this.setState({
                    primaryWHModalOpen: true,
                    modalType: 2,
                    primaryWhModalMsg: 'Unable to add to cart. There is insufficient quantity on hand to fullfill the quantity you have entered.'
                })
            }
        }

        if (addToCart) {
            //this.setState({
            //    itemForCart: item
            //})
            await this.availabilityPreCheck(item)
            //await this.addToCart(item);
        }
    }

    async availabilityPreCheck(item) {
        this.props.loaderOn();
        item.qty = document.getElementById(item.itemKey).valueAsNumber;
        item.deliverToManager = this.state.checked;
        item.dispatchChargeId = this.state.selectedDeliveryChargeId;
        item.dispatchType = this.state.selectedDeliveryOption;
        console.log('in pre-check', this.state.selectedDeliveryCharge)
        var dl = new DataLayer();

        //need to make sure we are checking correct WH here for item. Reserved WH vs Fullfillment WH
        let response = await dl.Post('/shop/checkavailabletopromise?warehouseCode=' + item.reservationWHCode, item, false);
        if (!response.errorOccurred) {
            if (document.getElementById(item.itemKey).valueAsNumber > response.data.qtyAvailable) {
                this.setState({
                    primaryWHModalOpen: true,
                    modalType: 2,
                    primaryWhModalMsg: 'Unable to add to cart. There is insufficient quantity on hand to fullfill the quantity you have entered.'
                })
                this.props.loaderOff();
            } else {
                this.addToCart(item);
            }
        } else {
            this.props.loaderOff();
            this.setState({
                primaryWHModalOpen: true,
                modalType: 2,
                primaryWhModalMsg: 'An error occurred while adding to cart. Please try again.'
            })
        }
    }

    async addItemToCart(item) {
        this.setState({
            primaryWHModalOpen: false
        })
        await this.availabilityPreCheck(item);
        //await this.addToCart(item);
    }


    async addToCart(item) {
        //alert(document.getElementById(stockId).valueAsNumber);
        let procCode1 = this.TMAUser.data.countryId == 6 ? '991527' : '991529';
        let procCode2 = this.TMAUser.data.countryId == 6 ? '991528' : '991530';
            

        if (item.processingCode == procCode1 || item.processingCode == procCode2) {
            if (this.state.roadshowItem.onInvoice || this.state.roadshowItem.onOrder || this.state.roadshowItem.inOpenCart) {
                toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Unable to add Item. Item has already been ordered</span>, {
                    closeButton: false
                });
                return;
            }
            if (document.getElementById(item.itemKey).valueAsNumber > 1) {
                toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Unable to add Item. Only 1 is allowed.</span>, {
                    closeButton: false
                });
                return;
            }
            if (this.state.roadshowItem.cartItemCount > 0) {
                toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Unable to add Item. Cart has other items.</span>, {
                    closeButton: false
                });
                return;
            }
        } else {
            if (this.state.roadshowItem.inOpenCart) {
                toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Unable to add Item. Cart Contains Roadshow Item</span>, {
                    closeButton: false
                });
                return;
            }
        }


        
        if (document.getElementById(item.itemKey).value == "" || document.getElementById(item.itemKey).valueAsNumber < 1) {
            toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Please give a valid Qty.</span>, {
                closeButton: false
            });

        } else {

            this.props.loaderOn();
            item.qty = document.getElementById(item.itemKey).valueAsNumber;
            item.deliverToManager = this.state.checked;
            item.dispatchChargeId = this.state.selectedDeliveryChargeId;
            item.dispatchType = this.state.selectedDeliveryOption;
            console.log('In State JJJJJJJJJJJJJJJJJJJJJJ ', this.state.selectedDeliveryCharge)
            console.log('Item fields ', item);
            var dl = new DataLayer();
            let response = await dl.Post('/common/addtocart', item, false);
            if (response.errorOccurred) {
                //toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Error Occurred.</span>, {
                //    closeButton: false
                //});
                this.setState({ shopErrorModalOpen: true, shopErrorMsg: response.errorMessage });
            } else {
                toast.success(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp; {document.getElementById(item.itemKey).valueAsNumber == 1 ? "Item added successfully." : "Items added successfully."} </span>, {
                    closeButton: false
                });
                this.setState({
                    hasOpenCart: true
                })
                this.props.updateCartCount(response.data);
            }
            let roadShowItemResponse = await dl.Get("/demonstrator/checkForRoadshowItem")
            this.setState({
                roadshowItem: roadShowItemResponse.data
            });

        }
        this.props.loaderOff();
    }

    getPagination() {
        let isFirst = this.state.selectedPage == 1 ? true : false;
        let isLast = this.state.maxPages == this.state.selectedPage ? true : false;
        return (
            <MDBPagination circle style={{ justifyContent: "center" }}>
                <MDBPageItem disabled={isFirst}>
                    <MDBPageNav className="page-link" onClick={() => this.getPage(this.state.selectedPage - 1, this.state.maxPages, this.state.filteredData)}>
                        &laquo;
                    </MDBPageNav>
                </MDBPageItem>
                {
                    this.state.pages.map((pageNo) => {
                        let active = pageNo == this.state.selectedPage ? true : false;
                        return (

                            <MDBPageItem active={active}>
                                <MDBPageNav className="page-link" onClick={() => this.getPage(pageNo, this.state.maxPages, this.state.filteredData)}>
                                    {pageNo}
                                </MDBPageNav>
                            </MDBPageItem>

                        )
                    })
                }
                <MDBPageItem disabled={isLast}>
                    <MDBPageNav className="page-link" onClick={() => this.getPage(this.state.selectedPage + 1, this.state.maxPages, this.state.filteredData)}>
                        &raquo;
                    </MDBPageNav>
                </MDBPageItem>

            </MDBPagination>
        );
    }

    getButton(item) {
        var countryId = this.TMAUser.data.countryId;
        if (!item.preventOrdering) {
            return (
                <MDBRow>
                    <MDBCol>
                        <MDBInput id={item.itemKey} min={0} type="number" label="Qty" required />
                    </MDBCol>
                    <MDBCol className="text-center">
                        {countryId === 6 ? <MDBBtn type="submit" tag="a" color="cyan" floating onClick={() => this.checkAvailability(item)}>
                            <MDBIcon icon="cart-plus" />
                        </MDBBtn> : <MDBBtn type="submit" tag="a" color="cyan" floating onClick={() => this.addToCart(item)}>
                            <MDBIcon icon="cart-plus" />
                        </MDBBtn>}
                        

                    </MDBCol>
                </MDBRow>
            );
        } else {
            return (
                <MDBRow>
                    <MDBCol className="text-center">
                        Out of stock, cannot be ordered.<hr className="hr_grey" />
                    </MDBCol>
                </MDBRow>
            );
        }
    }

    getParams(item) {
        if (item.showOutOfStock) {
            if (item.preventOrdering) {
                return (
                    <span>( <MDBIcon icon="exclamation-triangle" className="red-text" /> out of Stock)</span>
                );
            } else {
                return (
                    <span>( <MDBIcon icon="exclamation-triangle" className="red-text" /> Low on Stock)</span>
                );
            }
        }
    }

    searchList(phrase) {
        let arr = this.state.shopData.filter((item) => (item.recognition.toString().includes(phrase)) || item.processingCode.toUpperCase().includes(phrase.toUpperCase()) || (item.invoiceDescription.toUpperCase().includes(phrase.toUpperCase())))
        this.setState({
            filteredData: arr,
            maxPages: Math.ceil(arr.length / this.state.pageSize)
        });
        this.getPage(1, Math.ceil(arr.length / this.state.pageSize), arr);

    }

    async reloadDispatchOpts() {
        if (this.state.hasOpenCart) {
            this.setState({
                clearCartModalOpen: true
            })
        } else {
            this.setState({
                dispatchTypeOpen: true
            })
            await this.getDispatchOptions();
        }
    }

    getHot(item, forHot) {
        if (forHot) {
            if (item.hotItem) {
                return (
                    <MDBCardBody>
                        <div>
                            <div className="right-side-meta"><MDBIcon style={{ fontSize: '25px' }} icon="fire-alt" className="red-text" />&nbsp;Hot Item</div>
                        </div>
                    </MDBCardBody>
                )
            }
        } else {
            if (item.saving > 0) {
                return (
                    <div>
                        <h5><MDBBadge className="priceBadge" color="secondary">Price: {this.formatter.formatCurrency(item.d)}<br /><span style={{ fontSize: "10px", fontWeight: "normal" }}>(excl vat)</span></MDBBadge></h5>
                        <MDBBadge className="specialBadge" color="transparent"><span style={{ color: 'red', fontSize: '14px', fontWeight: 'normal' }}>Save: {this.formatter.formatCurrency(item.saving)}</span></MDBBadge>
                    </div>
                )
            } else {
                return (
                    <div>
                        <h5><MDBBadge className="priceBadge" color="secondary">Price: {this.formatter.formatCurrency(item.d)}<br /><span style={{ fontSize: "10px", fontWeight: "normal" }}>(excl vat)</span></MDBBadge></h5>
                        
                    </div>
                )
            }
        }
    }

    getAvailability(item) {
        if (this.TMAUser.data.countryId === 6) {
            if (this.state.selectedDeliveryOption == 2) {
                if (item.inStockPrimary) {
                    return <div><span style={{ color: "green", fontSize: "12px", fontWeight: "bold" }}><MDBIcon fas icon="check" />&nbsp;In Stock - Primary&nbsp;({item.onhandPrimary})</span>&nbsp;<span style={{ color: "red", fontSize: "12px", fontWeight: "bold" }}>({item.reservedP})</span><br /><br /></div>
                } else {
                    return <div><span style={{ color: "red", fontSize: "12px", fontWeight: "bold" }}><MDBIcon fas icon="times" />&nbsp;Not In Stock - Primary</span><br /><br /></div>
                }
            } else {
                if (item.inStockPrimary && item.inStockSecondary) {
                    return <div>
                        <span style={{ color: "green", fontSize: "12px", fontWeight: "bold" }}><MDBIcon fas icon="check" />&nbsp;In Stock - Primary&nbsp;({item.onhandPrimary})</span>&nbsp;<span style={{ color: "red", fontSize: "12px", fontWeight: "bold" }}>({item.reservedP})</span><br />
                        <span style={{ color: "green", fontSize: "12px", fontWeight: "bold" }}><MDBIcon fas icon="check" />&nbsp;In Stock - GP&nbsp;({item.onhandSecondary})</span>&nbsp;<span style={{ color: "red", fontSize: "12px", fontWeight: "bold" }}>({item.reservedS})</span><br /><br />
                    </div>
                } else if (item.inStockPrimary) {
                    return <div>
                        <span style={{ color: "green", fontSize: "12px", fontWeight: "bold" }}><MDBIcon fas icon="check" />&nbsp;In Stock - Primary&nbsp;({item.onhandPrimary})</span>&nbsp;<span style={{ color: "red", fontSize: "12px", fontWeight: "bold" }}>({item.reservedP})</span><br />
                        <span style={{ color: "red", fontSize: "12px", fontWeight: "bold" }}><MDBIcon fas icon="times" />&nbsp;Not In Stock - GP</span><br /><br />
                    </div>
                } else if (item.inStockSecondary) {
                    return <div>
                        <span style={{ color: "red", fontSize: "12px", fontWeight: "bold" }}><MDBIcon fas icon="times" />&nbsp;Not In Stock - Primary</span><br />
                        <span style={{ color: "green", fontSize: "12px", fontWeight: "bold" }}><MDBIcon fas icon="check" />&nbsp;In Stock - GP&nbsp;({item.onhandSecondary})</span>&nbsp;<span style={{ color: "red", fontSize: "12px", fontWeight: "bold" }}>({item.reservedS})</span><br /><br />
                    </div>
                }
            }
        }
    }

    render() {
        let header = "Shop (" + this.props.getRouteParam() + ")"
        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        let shipId = this.TMAUser.data.shipId;
        return (
            <div id="top">
                <HeaderShop headerText={header}
                    subHeaderText="(Please note if there is no activity on your cart for 30mins or more it will automatically be cleared)"
                    placeholderText="Search"
                    searchList={this.searchList}
                    reloadDispatchOpts={this.reloadDispatchOpts}
                    countryId={this.TMAUser.data.countryId}
                    selectedDispatchText={this.state.selectedDispatchText}
                    dispatchType={this.state.selectedDeliveryOption}
                    managerChecked={this.state.checked }
                />
                
                <MDBRow>
                    {this.state.shopSuspended ? <div><h5>Shop has temporarily been suspended by your distributor. Please check back soon.</h5></div> :
                        this.state.displayData.map((item) => {

                            return (

                                <MDBCol xl="3" lg="4" md="6" sm="12" className="mb-r" >
                                    <div key={item.itemKey}>
                                        <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                                            {/*<MDBCardImage className="img-fluid" src={`https://tupp.tuppafrica.co.za/images/virtualstore/` + item.stockId + `.jpg`} waves />*/}
                                            <div>
                                            {this.getHot(item, true)}

                                            <MDBCardImage className="img-fluid" src={item.hasImage ? item.shipStockId > 0 ? `https://tupp.tuppafrica.co.za/Images/virtualstore/` + shipId + `_` + item.shipStockId + `.jpg` : `https://tupp.tuppafrica.co.za/Images/virtualstore/` + item.stockId + `.jpg` : `https://tupp.tuppafrica.co.za/images/virtualstore/noimage.png`} />
                                            
                                            
                                                {this.getHot(item, false)}
                                                </div>
                                            <br />
                                            <MDBCardText>
                                                <span style={{ fontSize: "16px" }}><strong>{item.processingCode}  </strong>{item.componentList != null ? <div onClick={() => this.showComponents(item) } style={{cursor: "pointer"} }><MDBIcon fas icon="question" /></div>:<div></div>}</span>{this.getParams(item)}<br />
                                                <span style={{ fontSize: "12px" }}>{item.invoiceDescription}</span><br />
                                                {this.getAvailability(item) }
                                                <span style={{ fontSize: "16px" }}>Recognition:&nbsp;<strong>{this.formatter.formatCurrency(item.recognition)}</strong></span><br />
                                            </MDBCardText>
                                            <hr className="hr_grey" />
                                            {/*<div className="flex-row text-center" >*/}

                                            {this.getButton(item)}



                                            {/*</div>*/}
                                        </MDBCard>
                                    </div>
                                </MDBCol>
                            )

                        })
                    }
                </MDBRow>
                {this.state.shopSuspended ? <div></div> :
                    <MDBRow className="mt-4">
                        <MDBCol>

                            {this.getPagination()}

                        </MDBCol>
                    </MDBRow>
                }
                <MDBModal isOpen={this.state.errorModalOpen} toggle={this.state.errorModalOpen} centered>
                    <MDBModalHeader>Alert</MDBModalHeader>
                    <MDBModalBody>
                        {this.state.shopErrorMsg}
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={this.toggleErrorInfo}>Ok</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>
                <MDBModal isOpen={this.state.dispatchTypeOpen} toggle={this.state.dispatchTypeOpen} centered>
                    <MDBModalHeader><span style={{ color: "green" }}><MDBIcon fas icon="truck" /></span>&nbsp;Dispatch Options <br /><span style={{ fontWeight: "bold", fontSize: "14px"} }>(Item availability may be affected by your choice of dispatch)</span> </MDBModalHeader>
                    <MDBModalBody>
                        <div key="DelOpts">
                            
                            {this.TMAUser.data.countryId == 6 && this.TMAUser.data.statusCode1 == "D" && this.state.showDeliverToManager ? <div hidden={this.state.isCollection} style={{ fontWeight: "bold" }}>



                                <MDBInput checked={this.state.checked} getValue={this.setChecked} value={this.state.checked} label="Deliver To My Manager" type="checkbox" name="deliverMan" id="deliverMan">
                                    <div style={{ marginLeft: "35px", fontSize: "12px", fontWeight: "normal" }} id='helperTextExample' className='form-helper'>
                                        (PLEASE NOTE, IF YOU CHECK THIS BOX, YOUR ORDER WILL BE DELIVERED TO YOUR MANAGERS ADDRESS)
                                    </div>
                                </MDBInput>



                            </div> : <div></div>}

                            <SelectSearch
                                options={this.state.deliveryOptions}
                                placeholder="Delivery Option"
                                value={this.state.selectedDeliveryOption}
                                search={false}
                                onChange={(selectedItem) => {
                                    this.filterCharges(selectedItem.value)
                                }}
                            />
                            <SelectSearch
                                options={this.state.filteredCharges}
                                placeholder="Delivery Charge"
                                value={this.state.selectedDeliveryCharge}
                                search={false}
                                onChange={(selectedItem) => {
                                    
                                    this.setState({
                                        selectedDeliveryCharge: selectedItem.value,
                                        selectedDispatchText: selectedItem.value.description,
                                        selectedDeliveryChargeId: selectedItem.value.dispatchChargeId
                                    })
                                    //this.updateCart();
                                }}
                            />

                        </div>
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={this.proceedToShop}>Continue to shop</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>
                <MDBModal isOpen={this.state.shopErrorModalOpen} toggle={this.state.shopErrorModalOpen} centered>
                    <MDBModalHeader><span style={{ color: "red" }}><MDBIcon fas icon="exclamation-circle" /></span>&nbsp;Oops</MDBModalHeader>
                    <MDBModalBody>
                        {this.state.shopErrorMsg}
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={() => this.setState({ shopErrorModalOpen: false})}>Ok</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>
                <MDBModal isOpen={this.state.clearCartModalOpen} toggle={this.state.clearCartModalOpen} centered>
                    <MDBModalHeader><span style={{ color: "red" }}><MDBIcon fas icon="exclamation-circle" /></span>&nbsp;Warning</MDBModalHeader>
                    <MDBModalBody>
                        Changing dispatch option will result in your cart being cleared. Do you wish to continue?
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={this.clearCartAndProceed}>Yes</MDBBtn>
                        <MDBBtn rounded color="secondary" onClick={() => this.setState({ clearCartModalOpen: false })}>No </MDBBtn>
                    </MDBModalFooter>
                </MDBModal>

                <MDBModal isOpen={this.state.primaryWHModalOpen} toggle={this.state.primaryWHModalOpen} centered>
                    <MDBModalHeader><span style={{ color: "red" }}><MDBIcon fas icon="exclamation-circle" /></span>&nbsp;Alert</MDBModalHeader>
                    <MDBModalBody>
                        {this.state.primaryWhModalMsg }
                    </MDBModalBody>
                    {this.state.modalType === 1 ? <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={() => this.addItemToCart(this.state.itemForCart) } >Yes</MDBBtn>
                        <MDBBtn rounded color="secondary" onClick={() => this.setState({ primaryWHModalOpen: false })}>No </MDBBtn>
                    </MDBModalFooter> : <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={() => this.setState({ primaryWHModalOpen: false })}>Close </MDBBtn>
                    </MDBModalFooter>}
                    
                </MDBModal>

                <MDBModal size="lg" isOpen={this.state.compModalOPen} toggle={this.state.compModalOPen} centered>
                    <MDBModalHeader><span style={{ color: "green" }}><MDBIcon fas icon="info-circle" /></span>&nbsp;Components</MDBModalHeader>
                    <MDBModalBody>
                        {this.state.componentList &&
                            this.state.componentList.map((item, index) => (
                                <MDBRow
                                    key={index}
                                    className="border-bottom py-2 align-items-center"
                                >
                                    <MDBCol md="4">
                                        <strong>{item.processingCode}</strong>
                                        <div>{item.invoiceDescription}</div>
                                    </MDBCol>

                                    <MDBCol>
                                        <small>Set Qty</small>
                                        <div>{item.qtyOnSet}</div>
                                    </MDBCol>

                                    <MDBCol>
                                        <small>QOH GP</small>
                                        <div>{item.avQtySecondary}</div>
                                    </MDBCol>

                                    <MDBCol md="2">
                                        <small>QOH Primary</small>
                                        <div>{item.avQtyPrimary}</div>
                                    </MDBCol>
                                    <MDBCol md="2">
                                        <small>Reserved Prim</small>
                                        <div>{item.reservedPrimary}</div>
                                    </MDBCol>
                                    <MDBCol md="2">
                                        <small>Reserved GP</small>
                                        <div>{item.reservedSecondary}</div>
                                    </MDBCol>
                                </MDBRow>
                            ))}
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={() => this.setState({ compModalOPen: false })}>Close </MDBBtn>
                    </MDBModalFooter>

                </MDBModal>

                

                <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={5000}
                />
            </div>

        )
    }
}

export default Shop;


